module.exports = __webpack_public_path__ + "img/logo_lime.fe539e32.svg";